import logo from './logo.svg';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Verkoop from './pages/verkoop/Verkoop';
import Afrekenen from './pages/afrekenen/Afrekenen';
import Winkelwagen from './pages/winkelwagen/Winkelwagen';
import Confirmatie from './pages/confirmatie/Confirmatie';
import './App.css';

import { BrowserRouter } from 'react-router-dom'


function App() {
  return (
    <Router>
                <Routes>
                <Route path="/verkoop" element={<Verkoop />} />
                <Route path="/winkelwagen" element={<Verkoop />} />
                <Route path="/afrekenen" element={<Afrekenen />} />
                <Route path="/confirmatie" element={<Confirmatie />} />
            </Routes>
        </Router>
  );
}

export default App;
